module.exports = __webpack_public_path__ + "img/energy-land-use-finalprintable-2021.pdf";